import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toHandlers as _toHandlers, mergeProps as _mergeProps, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78fe7324"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "calendarPicker" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "hidden" }, "캘린더 선택", -1))
const _hoisted_3 = { class: "cal-from" }
const _hoisted_4 = { class: "cal-from-wrap" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["value", "onFocus"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "-", -1))
const _hoisted_8 = { class: "cal-to" }
const _hoisted_9 = { class: "cal-to-wrap" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["value", "onFocus"]

import { ref, watch } from 'vue';
import { DatePicker } from 'v-calendar';

export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarPicker',
  emits: ['setDates'],
  setup(__props, { emit }) {


/**** data -------------------- */
var dateFrom = ref(new Date(2023, 0, 1));
var dateTo = ref(new Date());
var selectAttribute = ref({
  highlight: {
    color: 'teal',
  },
});
var dateStart = ref('');
var dateEnd = ref('');
/**** methods ---------------- */
const transYYYYMMDD = async (UTC: any, type: string) => {
  let year, month, date: string | number;
  year = UTC.getFullYear();
  month = UTC.getMonth() + 1;
  if (month < 10) {
    month = `0${month}`;
  }
  date = UTC.getDate();
  if (typeof date === 'number' && date < 10) {
    date = `0${date}`;
  }
  if (type === 'start') {
    dateStart.value = `${year}-${month}-${date}`;
    emit('setDates', dateStart.value, dateEnd.value);
  } else {
    dateEnd.value = `${year}-${month}-${date}`;
    emit('setDates', dateStart.value, dateEnd.value);
  }
};
/**** content -----------------
 * 캘린더 피커
 * /
 */
/**** hook -------------------- */
watch(
  () => dateFrom.value,
  (newValue) => {
    transYYYYMMDD(newValue, 'start');
    transYYYYMMDD(dateTo.value, 'end');
  },
  { deep: true }
);
watch(
  () => dateTo.value,
  (newValue) => {
    transYYYYMMDD(dateFrom.value, 'start');
    transYYYYMMDD(newValue, 'end');
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(DatePicker), {
        modelValue: _unref(dateFrom),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(dateFrom) ? (dateFrom).value = $event : dateFrom = $event)),
        popover: false,
        "select-attribute": _unref(selectAttribute)
      }, {
        default: _withCtx(({ togglePopover, inputValue, inputEvents }) => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "cal-btn hidden-font",
              onClick: ($event: any) => (togglePopover())
            }, "시작일", 8, _hoisted_5),
            _createElementVNode("input", _mergeProps({
              class: "cal-input-from",
              value: inputValue
            }, _toHandlers(inputEvents, true), {
              onFocus: ($event: any) => (togglePopover())
            }), null, 16, _hoisted_6)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "select-attribute"])
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_unref(DatePicker), {
        modelValue: _unref(dateTo),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(dateTo) ? (dateTo).value = $event : dateTo = $event)),
        popover: false,
        "select-attribute": _unref(selectAttribute)
      }, {
        default: _withCtx(({ togglePopover, inputValue, inputEvents }) => [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "cal-btn hidden-font",
              onClick: ($event: any) => (togglePopover())
            }, "종료일", 8, _hoisted_10),
            _createElementVNode("input", _mergeProps({
              class: "cal-input-to",
              value: inputValue
            }, _toHandlers(inputEvents, true), {
              onFocus: ($event: any) => (togglePopover())
            }), null, 16, _hoisted_11)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "select-attribute"])
    ])
  ]))
}
}

})